import React from "react";
import { Text } from "react-native";

export const BaseText = (props) => {
  return (
    <Text style={[{ fontSize: 16, color: "#828282" }, props.style]} {...props}>
      {props.children}
    </Text>
  );
};
